import React, { Component } from "react";
import { connect } from "react-redux";
import { changeLang } from "../../actions/langAction";
import { setDynamic } from "../../actions/dynamicAction";
import LayoutOperation from "../../components/layout_operation";
import Cookies from "js-cookie";
import ServiceApi from "../../services/ServiceApi";
import { Input, Select, DatePicker, Modal } from "antd";
import "./report.css";
import moment from "moment";
import XLSX from 'xlsx';
import NoReportSvg from "./no-report.svg";
const { Search } = Input;
const { Option } = Select;

const reportFunction = [
  {
    id: 0,
    name: "Job",
    report: [
    ],
  },
];

class dynamic_report extends Component {
  constructor(props) {
    super(props);
    this.state = {
      functionId: 0,
      reportId: "",
      form_report: [],
      data_report: {},
      visible_export: false,
      master_report: [],
      report_id: ""
    };
  }

  async componentDidMount() {
    const get_report_master_list = await ServiceApi.post("get_report_master_list",
      {
        "company_id": Cookies.get("companyid")
        , "operator_id": Cookies.get("operator_id")
        , "project_id": Cookies.get("project_id")
        , "report_id": null
        , "report_module": null
        , "report_group": null
        , "report_type": null
        , "report_name": null
      }
    );

    this.setState({
      master_report: get_report_master_list.data.data,

    })

  }
  renderComponet = (type, fild) => {
    if (type === "date") {
      return (
        <DatePicker
          onChange={(e) =>
            this.state.data_report[fild] = moment(e).format("YYYY-MM-DD")
          }
          style={{ color: "#000F9F", width: "300px" }}
          name="date"
        />
      )
    }
    else if (type === "text") {
      if (fild === "@company_id") {
        this.state.data_report[fild] = Cookies.get("companyid");
      }
      if (fild === "@operator_id") {
        this.state.data_report[fild] = Cookies.get("operator_id");
      }
      if (fild === "@project_id") {
        this.state.data_report[fild] = Cookies.get("project_id");
      }
      return (
        <input
          onChange={(e) =>
            this.state.data_report[fild] = e.target.value
          }
          value={fild === "@company_id" ? Cookies.get("companyid") :
            fild === "@operator_id" ? Cookies.get("operator_id") : fild === "@project_id" ? Cookies.get("project_id") : ""}
          style={{ color: "#000F9F", width: "300px" }}
          disabled={true}
        />
      )
    }

  }
  genReport = async () => {
    this.setState({
      visible_export: true
    })
  }
  exportToXLSX = async () => {
    var setData = "";
    for (const [key, value] of Object.entries(this.state.data_report)) {
      setData += `${key}:` + "$" + `${value}` + "##";
    }
    const get_from_report = await ServiceApi.post("generate_report", {
      "company_id": Cookies.get("companyid")
      , "operator_id": Cookies.get("operator_id")
      , "project_id": Cookies.get("project_id")
      , "report_id": this.state.report_id
      , "param_text": setData.substring(0, setData.length - 2)
    });
    var result_array = [];
    var setHerder = {};
    const wb = XLSX.utils.book_new();
    for (const [key, value] of Object.entries(get_from_report.data)) {
      if (`${key}` != "result") {
        for (let i = 0; i < get_from_report.data[`${key}`].length; i++) {
          for (const [key_h, value_h] of Object.entries(get_from_report.data[`${key}`][i])) {
            setHerder[`${key_h}`] = `${key_h}`;
          }
          result_array.push(get_from_report.data[`${key}`][i])
        }
        let binaryWS = XLSX.utils.json_to_sheet([setHerder, ...result_array], { skipHeader: true });
        XLSX.utils.book_append_sheet(wb, binaryWS, `${key}`);
        result_array = [];
        setHerder = {};
        XLSX.writeFile(wb, this.state.file_name + ".xlsx");
      }
    }
    window.location.reload();
  }
  onChangeReport = async (value) => {
    const get_from_report = await ServiceApi.post("get_report_param_list", {
      "company_id": Cookies.get("companyid")
      , "operator_id": Cookies.get("operator_id")
      , "project_id": Cookies.get("project_id")
      , "report_id": value
    });
    this.setState({
      report_id: value,
      form_report: get_from_report.data.data
    })
  }
  render() {
    const title = "Report";
    return (
      <LayoutOperation active={7}>
        <Modal
          title="Export Excel File"
          centered
          visible={this.state.visible_export}
          footer={null}
          closable={false}
          width={200}
          className="custom-modal-map-large"
        >
          <div className="row" style={{ textAlign: "center", padding: "20px" }}>
            <div className="col-6">
              <span>ตั้งชื่อไฟล์ : </span>
            </div>
            <div className="col-6">
              <Input
                placeholder="ตั้งชื่อไฟล์"
                onChange={(e) =>
                  this.setState({
                    file_name: e.target.value
                  })
                }
                style={{ width: "300px", marginLeft: "10px" }}
              />
            </div>
            <div className="col-12 mt-3" style={{ textAlign: "center" }}>

              <button
                onClick={() => this.setState({
                  visible_export: false
                })}
                className="btn btnclear"
              >
                Close
        </button>
              <button
                onClick={() => this.exportToXLSX()}
                className="btn btnconfirm"
              >
                OK
          </button>
            </div>
          </div>

        </Modal>
        <div className="wrapper-header">
          <div className="container-fluid">
            <div className="d-flex job-header">
              <div className="d-flex align-content-center flex-wrap mr-auto">
                <img
                  src={ServiceApi.absoluteUrl("/icon/bbtec/header/Report.svg")}
                  alt={title}
                  title={title}
                />
                <h2 className="text-white ml-3" style={{ marginRight: "10px" }}>{title}</h2>
              </div>
            </div>
          </div>
        </div>
        <div className="wrapper-body my-3">
          <div className="container-fluid">
            <div className="row no-gutters">
              <div className="col-12 col-sm-auto" style={{ width: 287 }}>
                <div className="report-item">
                  <div className="report-header">
                    <img
                      src={ServiceApi.absoluteUrl("/icon/icon_function.svg")}
                      alt="Function"
                      title="Function"
                    />
                    FUNCTION
                  </div>
                  <Search
                    placeholder="Search"
                    allowClear
                    style={{ marginTop: 10 }}
                  />
                  <div className="report-function-wrapper">
                    {reportFunction.map((item, index) => (
                      <div
                        className={
                          item.id === this.state.functionId
                            ? "report-function-item active"
                            : "report-function-item"
                        }
                        onClick={() => {
                          if (this.state.functionId !== index) {
                            this.setState({ functionId: index, reportId: "" });
                          }
                        }}
                        key={index}
                      >
                        <div className="report-function-name">{item.name}</div>
                        <div className="report-function-total">
                          {item.report.length} reports
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm">
                <div className="report-col-wrapper">
                  <div className="row">
                    <div className="col-12">
                      <div className="report-item">
                        <div className="report-header">
                          <img
                            src={ServiceApi.absoluteUrl(
                              "/icon/icon_select_report.svg"
                            )}
                            alt="Select report"
                            title="Select report"
                          />
                          SELECT REPORT
                        </div>
                        <div className="report-selector-wrapper">
                          <div className="col-12 col-sm-6 col-sm-push-3">

                            <Select
                              placeholder="Please select report"
                              className="w-100"
                              onChange={(value) => this.onChangeReport(value)}

                            >
                              {this.state.master_report.map((item, index) => (
                                <Option value={item.report_id} key={index}>
                                  <span className="default-thai-font">
                                    {item.report_name}
                                  </span>
                                </Option>
                              ))}
                            </Select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-12">
                      <div className="report-item">
                        <div className="report-header">
                          <img
                            src={ServiceApi.absoluteUrl(
                              "/icon/icon_parameter.svg"
                            )}
                            alt="Parameter"
                            title="Parameter"
                          />
                          PARAMETER
                        </div>
                        <div className="report-parameter-wrapper">
                          <div className={this.state.form_report.length === 0 ? "divshow no-report-wrapper" : "divhide"}>
                            <img src={NoReportSvg} alt="No Report" />
                            <p>No Report</p>
                          </div>
                          <div className={this.state.form_report.length === 0 ? "divhide" : "row divshow"} style={{ marginTop: "100px" }}>

                            {this.state.form_report.map((item, index) => (
                              <>
                                <div className="col-4 mt-2" style={{ textAlign: "right" }}>
                                  <span className="textReport">{item.param_name}{" : "}</span>
                                </div>
                                <div className="col-auto  mt-2">
                                  {this.renderComponet(item.param_obj_type, item.param_value)}

                                </div>
                                <div className="col-3  mt-2">
                                  <span className="textReport" style={{ color: "red", textAlign: "left" }}>
                                    {item.param_desc}

                                  </span>

                                </div>
                              </>
                            ))}
                            <div className="col-12">
                              <div className="mt-5 text-center">
                                <button

                                  className="btn btnclear"
                                >
                                  Clear
        </button>
                                <button

                                  className="btn btnconfirm"
                                  onClick={() => this.genReport()}
                                >
                                  Confirm
        </button>
                              </div>
                            </div>

                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LayoutOperation>
    );
  }
}
const mapStateToProps = (state) => ({
  lang: state.lang,
  dynamicReducer: state.dynamicReducer,
});
const mapDispacthToProps = (dispatch) => {
  return {
    changeLang: (data) => dispatch(changeLang(data)),
    setDynamic: (data, visible) => dispatch(setDynamic(data, visible)),
  };
};

export default connect(mapStateToProps, mapDispacthToProps)(dynamic_report);
